import React from 'react';
import DatePicker from 'react-datepicker';

class RuleBuilderDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.dateSelected = this.dateSelected.bind(this);
  }

  dateSelected(date) {
    this.props.onChange({
      [this.props.stateKey]: moment.utc(
        date.format('YYYY MM DD'),
        'YYYY MM DD',
      ),
    });
  }

  render() {
    return (
      <span className="Rule-input Rule-datePicker">
        <DatePicker
          className="NewInput NewInput--white"
          dateFormat="MM/DD/YYYY"
          onChange={this.dateSelected}
          placeholderText={t('common.date_format')}
          selected={this.props.selected}
        />
      </span>
    );
  }
}

export default RuleBuilderDatePicker;
